import './MovieBanner.css'
import { Rating } from '@material-ui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { emptySelectedMovie, selectedMovie, setCharacter } from '../../Redux/Action';
import axios from 'axios';
import { useEffect, useState } from 'react';
import blank from "../assets/blank-poster.jpeg"


 const MovieBanner = () => {
 const movie = useSelector(state=>state.movie.selectedMovie)
 const [totalReview, setTotalReview] = useState()
 const { id } = useParams()
 const dispatch = useDispatch()

 const selectMovie = async () => {
    const response = await axios
        .get(`https://moviesteamd.herokuapp.com/api/v1/movie/${id}`)
        // .catch((err)=>{
        //     console.log('err', err)
        // })
        console.log('movie by id',response.data)
        console.log('total review =', response.data)
        dispatch(selectedMovie(response.data.data))
        dispatch(setCharacter(response.data.data.cast))
  } 

  useEffect(
    () => {
    selectMovie()
    dispatch(emptySelectedMovie())
    }, [id]
  )

    return ( movie.length === 0 
        ? 
        <div className='banner'>
            <img src={blank} />
            <div className='banner banner-opacity'></div>
            <div className='banner-content'>
                <h2>Loading..</h2>
                <div className='rating'><Rating size='large'  value='5' readOnly></Rating><span className='rating-text'>2200 Reviews</span></div>
                <p>Loading..</p>
                <div className='banner-btn-wrapper'>
                    <div className='btn-banner watch'>Watch Trailer</div>
                    <div className='btn-banner watchlist'>Add to Watchlist</div>
                </div>
            </div>
        </div>
        :
        movie.map(film=>(
            <div className='banner'>
                <img src={film.backdrop_path ? `https://image.tmdb.org/t/p/original/${film.backdrop_path}` : blank} />
                <div className='banner banner-opacity'></div>
                <div className='banner-content'>
                    <h2>{film.title}</h2>
                    <div className='rating'><Rating size='large'  value={Math.round(film.rating/2)} readOnly></Rating><span className='rating-text'>{film.total_review}Reviews</span></div>
                    <p> {film.overview}</p>
                    <div className='banner-btn-wrapper'>
                        <div className='btn-banner watch'>Watch Trailer</div>
                        <div className='btn-banner watchlist'>Add to Watchlist</div>
                    </div>
                </div>
            </div>
                    )
                )
         )
}

export default MovieBanner